import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';

import utils from './utils';
import auth from './auth';
import user from './user';
import sponsorshipEvent from './sponsorshipEvent';

Vue.use(Vuex);
// const plugins = [createPersistedState({
//   key: 'auth',
//   reducer: state => ({ auth: state.auth }),
// })];

export default new Vuex.Store({
  // plugins,
  modules: {
    utils,
    auth,
    user,
    sponsorshipEvent,
  },
});
